module.exports = __webpack_public_path__ + "img/richelieu-logo.160e1c8b.jpg";